<template>
  <select-base
    v-model="value"
    :disabled="disabled"
    :require="require_"
    :multiple="multiple"
    :label="'Contador'"
    :label-select="'nomeCompleto'"
    :carregar="carregarContadores"
    @input="enviarParaPai"
  />
</template>

<script>
import api from './api'

export default {
  name: 'GrupoPermissoesSelect',
  components: {
    SelectBase: () => import('@app/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    require_: {
      get() {
        return this.require
      },
    },
  },
  methods: {
    carregarContadores() {
      return api.getContadores()
    },
    enviarParaPai() {
      this.$emit('input', this.value)
    },
  },
}
</script>
